import QueryManager from "../../../global/utils/QueryManager";
import {getLocalStorageKey} from "../../../settings";
import {AlertsFiltersTypes} from "./Alerts.filters.types";

const curLocalStorageKey = getLocalStorageKey("alerts_filters");

let userFiltersSerializableDates = [AlertsFiltersTypes.AlertForDate]
let userFiltersSerializableJoins = []

export class AlertsFiltersManagerClass extends QueryManager {}

const AlertsFiltersManager = new AlertsFiltersManagerClass({
    serializable: {dates: userFiltersSerializableDates, joins: userFiltersSerializableJoins},
    localStorageKey: curLocalStorageKey
});

export default AlertsFiltersManager;